<template>
  <vue-perfect-scrollbar
    :settings="{ suppressScrollX: true, wheelPropagation: false }"
    class="h-100 rtl-ps-none ps scroll"
    style="height: 100%"
  >
    <div class="pa-5 relative">
      <v-app-bar
        :color="$vuetify.theme.dark ? 'dark' : 'grey lighten-5'"
        :dark="$vuetify.theme.dark"
        class=""
        fixed
        flat
      >
        <v-icon>mdi-account-circle-outline</v-icon>
        <div class="d-flex justify-space-between align-center w-full">
          <h6 class="ma-0 ml-1">
            <!-- {{ PropsAccessInfo && PropsAccessInfo.loginUserName }} 회원님 -->
            로그인 중
          </h6>
          <slot name="userDrawerCloseButton" />
        </div>
      </v-app-bar>
    </div>
    <div class="nav pa-5 mt-10">
      <v-btn
        large
        block
        :outlined="$route.fullPath !== '/home'"
        class="nav-item mb-2"
        @click="$emit('clickHome')"
      >
        홈
      </v-btn>
      <v-btn
        large
        block
        :outlined="$route.fullPath !== '/intro'"
        class="nav-item mb-2"
        @click="$emit('clickMoveMenu', 'intro')"
      >
        지피테라퓨틱스 소개
      </v-btn>
      <v-btn
        large
        block
        :outlined="$route.fullPath !== '/actinum'"
        class="nav-item mb-2"
        @click="$emit('clickMoveMenu', 'actinum')"
      >
        액티넘 정보
      </v-btn>
      <v-btn
        large
        block
        :outlined="$route.fullPath !== '/lamisil'"
        class="nav-item mb-2"
        @click="$emit('clickMoveMenu', 'lamisil')"
      >
        라미실 정보
      </v-btn>
      <v-btn
        large
        block
        :outlined="$route.fullPath !== '/betadine'"
        class="nav-item mb-2"
        @click="$emit('clickMoveMenu', 'betadine')"
      >
        베타딘 정보
      </v-btn>
      <v-btn
        large
        block
        :outlined="$route.fullPath !== '/cyclogest'"
        class="nav-item mb-2"
        @click="$emit('clickMoveMenu', 'cyclogest')"
      >
        사이클로제스트 정보
      </v-btn>
      <v-btn
        large
        block
        :outlined="$route.fullPath !== '/mr-visit'"
        class="nav-item mb-2"
        @click="$emit('clickMoveMenu', 'mr-visit')"
      >
        MR 방문접수
      </v-btn>
      <v-btn
        color="primary"
        large
        block
        outlined
        class="nav-item mb-2"
        @click="$emit('clickChangeUserInfo')"
      >
        <!-- <v-icon :color="$vuetify.theme.themes.light.secondary">mdi-shield-check-outline</v-icon> -->
        내 정보 관리
      </v-btn>
    </div>
  </vue-perfect-scrollbar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  name: "UserDrawer",
  props: {
    PropsAccessInfo: {
      type: [Object],
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["isDev", "meInfo"]),
  },
  mounted() {
    // console.log(this.meInfo);
  },
  methods: {
    showLoginLogs() {
      this.$refs.refUserLogs.showModal();
    },
    showUserInfoEditor() {
      this.$refs.refUserInfo.showModal();
    },
  },

};
</script>

<style lang="scss">
header.grey.lighten-5.theme--light.v-app-bar.v-app-bar--fixed.v-sheet.v-toolbar.v-toolbar--flat {
  top: 0;
}
.nav {
  .nav-item {
    justify-content: flex-start;
    border-radius: 20px;
    border-color: $primary-border-color;
    .v-icon {
      color: #000;
      margin-right: 5px;
    }
    span {
      color: #000;
    }
  }
}
</style>
